import { useEffect, useState } from 'react';
import { compose } from 'ramda';
import DropIn from 'braintree-web-drop-in-react';

import { viewExperiment } from '#src/lib/experimentation';

import './styles.scss';

import {
  buildBraintreeOptions,
  formatAmount,
  updateBraintreeAmount,
} from './helpers';

const BraintreeDropIn = ({
  amountDue: amountCents,
  onInstance,
  token,
  ...dropInProps
}) => {
  const [braintree, setBraintree] = useState(null);
  const [amount, setAmount] = compose(useState, formatAmount)(amountCents || 0);

  const showOptions =
    dataLayer?.find((x) => x?.options)?.options === 'yes' || false;

  useEffect(() => {
    const newAmount = formatAmount(amountCents);
    if (braintree) {
      updateBraintreeAmount(braintree, newAmount);
    }
    setAmount(newAmount);
  }, [amountCents, braintree, setAmount]);

  const handleInstance = (instance) => {
    // this will trigger useEffect, which will set the amounts
    setBraintree(instance);
    onInstance && onInstance(instance);

    const experiments = [
      'EXP_WBRT_2737_HUB_REMOVE_APPLE_GOOGLE_PAY',
      'EXP_WBRT_4995_HUB_REMOVE_PAYPAL',
    ];

    experiments.forEach((experiment) => {
      viewExperiment(experiment);
    });
  };

  return (
    <DropIn
      options={buildBraintreeOptions({
        authorization: token,
        amount,
        show: showOptions,
      })}
      {...dropInProps}
      onInstance={handleInstance}
    />
  );
};

export default BraintreeDropIn;
